var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Field from './Field';
import DatePicker from '../components/DatePicker';
var RFFDatePicker = function (_a) {
    var name = _a.name, inputVariant = _a.inputVariant, fullWidth = _a.fullWidth, variant = _a.variant, validate = _a.validate, otherProps = __rest(_a, ["name", "inputVariant", "fullWidth", "variant", "validate"]);
    return (React.createElement(Field, { name: name, validate: validate }, function (_a) {
        var input = _a.input, meta = _a.meta, props = __rest(_a, ["input", "meta"]);
        return (React.createElement(DatePicker, __assign({}, input, props, otherProps, { name: name, value: input.value || null, fullWidth: fullWidth, variant: variant, inputVariant: inputVariant, error: meta.touched && !!meta.error, helperText: meta.touched && meta.error, onChange: function (date) { return input.onChange(date); }, onBlur: input.onBlur })));
    }));
};
RFFDatePicker.defaultProps = {
    inputVariant: 'outlined',
    variant: 'inline',
    fullWidth: false,
    value: null,
    onChange: function () { },
    validate: function () { },
};
export default RFFDatePicker;
//# sourceMappingURL=DatePicker.js.map